import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MovieCategoryPage from "../pages/category/movie/page";
import TvCategoryPage from "../pages/category/tv/page";
import NewsCategoryPage from "../pages/category/news/page";
import DetailPage from "../pages/detail/page";
import NewsDetailPage from "../pages/news/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/movie",
    element: <MovieCategoryPage />,
  },
  {
    path: "/category/tv",
    element: <TvCategoryPage />,
  },
  {
    path: "/category/news",
    element: <NewsCategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;